import React from 'react';
import styled from 'styled-components';

import FeaturedItem from './FeaturedItem';
//import { Resource } from '../../../../types/Resource';
import FeaturedItemSkeleton from './FeaturedItemSkeleton';
import { Button } from '../../../genericComponents';
import { NavLink } from 'react-router-dom';

import FilterByNameIcon from '../../../../assets/images/sprites/FilterByName@2x.png';
import FilterByPriceIcon from '../../../../assets/images/sprites/FilterByPrice@2x.png';


const MarketPlaceFeatured = ({
  resources = [],
  handleWriteReview,
  onLockerButtonPress,
  loading,
  handleLoadMore,
  handleFilterResourcesByPrice,
  handleFilterResourcesByName,
}) => {
  return (
    <FeaturedContainer>
      <ContentContainer>
        <FeaturedHeader>
          <Title>Featured</Title>
          <Tabs>
            <Tab active={true}>Resouces</Tab>
            <Tab><NavLink to={'/schools'}>Schools</NavLink></Tab>
          </Tabs>
          <FiltersContainer>
            <FilterImage
              src={FilterByNameIcon}
              onClick={() => {
                handleFilterResourcesByName();
              }}
            />
            <FilterImage
              src={FilterByPriceIcon}
              onClick={() => {
                handleFilterResourcesByPrice();
              }}
            />
          </FiltersContainer>
        </FeaturedHeader>
        <>
          {loading
            ? Array.from({ length: 4 }).map((element,index) => <FeaturedItemSkeleton key={index}/>)
            : resources.map((item, index) => (
              <FeaturedItem
                item={item}
                key={index}
                onLockerButtonPress={onLockerButtonPress}
                handleWriteReview={handleWriteReview}
              />
            ))}
        </>
      </ContentContainer>
      {/* {!loading && (
        <LoadMoreButton onClick={() => handleLoadMore()}>
          Load More Resources
        </LoadMoreButton>
      )} */}
    </FeaturedContainer>
  );
};

export default MarketPlaceFeatured;

const FeaturedContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const ContentContainer = styled.div`
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
`;

const FeaturedHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 62px;
  width: 100%;
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;

const Title = styled.h1`&&&{
    color: ${props => props.theme.color.darkBlue};
    font-size: 2.8em;
    font-weight: bold;
    margin-top: 16px;
    @media (max-width: 720px) {
      font-size: 2.4em;
    }
  }
`;

const Tabs = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  border-bottom: 1px solid ${props => props.theme.color.gabaYellow};
  align-items: flex-end;
  height: 30px;
  justify-content: space-between;
  @media (max-width: 480px) {
    margin-top: 0px;
  }
`;

const Tab = styled('div')`
  height: 30px;
  width: 100px;
  text-align: center;
  border-bottom: ${props =>
    props.active ? `2px solid ${props.theme.color.gabaYellow}` : '0'};
`;

const FiltersContainer = styled.div`
  display: flex;
  margin-top: 16px
`;

const FilterImage = styled.img`
  margin-left: 10px;
  height: 40px;
`;

const LoadMoreButton = styled(Button)`
  align-self: center;
  margin-bottom: 30px;
`;

